import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../constants/common'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../Checkbox'
import { isRemoveAllEntityActionType } from '../../../Entity'
import { FieldStackedLabel } from '../../../Field'
import {
  FormFieldsContainer,
  FormFieldSelectNG,
  FormModal,
  formValidationSchemaNoChanged,
} from '../../../Form'
import {
  FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
  FormikEntityActionConfigFields,
  FormikField,
  getFormikCheckboxFieldValueProps,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { UserMultiSelect } from '../../../User'
import {
  REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
  RequestEditUserCommentFields,
} from '../RequestEditUserCommentFields'
import { getRequestEditUserModalEmptyValues } from '../RequestEditUserModal.utils'

import {
  REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
  REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
  REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT,
} from './RequestEditUserModalFields.constants'
import { isFormCommentsFieldsEqual } from './RequestEditUserModalFields.utils'

import * as styles from './RequestEditUserModalFields.module.css'

function RequestEditUserModalFields({
  actionTypes,
  id,
  userFieldName,
  userFieldProps,
  withTypeSelectError = true,
}) {
  const { t } = useTranslation()

  const { errors, setValues, values } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: getRequestEditUserModalEmptyValues(userFieldName),
    })

  const isComment = values[REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT]

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    return setModal(false)
  }

  function handleSaveNoticeValues({ values: noticeValues }) {
    setValues({
      ...values,
      ...noticeValues,
      [REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT]: true,
    })

    handleCloseModal()
  }

  function handleOpenNoticeModal() {
    const initialValues = isComment
      ? values
      : REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE

    setModal(
      <FormModal
        Fields={RequestEditUserCommentFields}
        containerProps={{
          boxSize: REQUEST_EDIT_USER_COMMENT_MODAL_BOX_SIZE,
          qaName: REQUEST_EDIT_USER_COMMENT_MODAL_QA_NAME,
        }}
        formBodyProps={{
          withNotifications: true,
        }}
        formFieldsProps={{ id }}
        formTitle='Modal.SendInvitationTitleKey'
        initialValues={initialValues}
        validationSchema={formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormCommentsFieldsEqual,
        })}
        onClose={handleCloseModal}
        onSubmit={handleSaveNoticeValues}
      />
    )
  }

  const checkboxTooltip = isRemoveAllEntityActionType(
    values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]
  )
    ? t('Modal.SendNotificationRemoveAllTypeDisabledCheckboxTooltipKey')
    : values[userFieldName].length === 0
      ? t('Modal.SendNotificationEmptyAssigneesTypeDisabledCheckboxTooltipKey')
      : null

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: withTypeSelectError ? errors[userFieldName] : undefined,
          options: actionTypes,
        }}
      >
        <FormikField
          {...userFieldProps}
          multi
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserMultiSelect}
          disabled={actionTypeValueIsRemoveAll}
          emptyValue={EMPTY_LIST}
          name={userFieldName}
        />
        <FormikField
          showTooltip
          Component={Checkbox}
          Field={Fragment}
          buttonProps={{
            className: styles.viewButton,
            text: t('Modal.TextViewBtnKey'),
            onClick: handleOpenNoticeModal,
          }}
          disabled={values[userFieldName].length === 0}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('Modal.SendNotificationLabelKey')}
          name={REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT}
          size={CHECKBOX_SIZE.small}
          tooltip={checkboxTooltip}
          type={CHECKBOX_TYPE.action}
        />
        {modal}
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default RequestEditUserModalFields
